module.exports = __webpack_public_path__ + "static/media/2.0a2273cc.jpg";